/* eslint-disable no-restricted-imports */

import { useQuery } from '@apollo/client';
import {
  AgreementFragment,
  ClientGetAgreementsToAcceptDocument,
  ClientRepresentativeGetAgreementsToAcceptDocument,
  LegalClientBeneficiaryGetAgreementsToAcceptDocument,
  LegalClientHeadGetAgreementsToAcceptDocument,
  LegalClientLegalHeadFirstHeadGetAgreementsToAcceptDocument,
  LegalClientRepresentativeGetAgreementsToAcceptDocument,
} from 'api/generated/graphql';
import { ClientIdentityType } from 'api/types/data';
import { useUser } from 'libs/providers';

export const useGetClientAgreements = () => {
  const { client } = useUser();

  let doc;

  switch (client?.type) {
    case ClientIdentityType.Client:
    case ClientIdentityType.ClientWithRepresentative:
      doc = ClientGetAgreementsToAcceptDocument;
      break;
    case ClientIdentityType.ClientRepresentative:
      doc = ClientRepresentativeGetAgreementsToAcceptDocument;
      break;
    case ClientIdentityType.LegalClientBeneficiary:
      doc = LegalClientBeneficiaryGetAgreementsToAcceptDocument;
      break;
    case ClientIdentityType.LegalClientHead:
      doc = LegalClientHeadGetAgreementsToAcceptDocument;
      break;
    case ClientIdentityType.LegalClientLegalHeadFirstHead:
      doc = LegalClientLegalHeadFirstHeadGetAgreementsToAcceptDocument;
      break;
    case ClientIdentityType.LegalClientRepresentative:
      doc = LegalClientRepresentativeGetAgreementsToAcceptDocument;
      break;
    default:
      throw new Error('client not found');
  }

  const { data, loading } = useQuery<{ agreements: AgreementFragment[] }>(doc, {
    variables: { id: client.id },
  });

  return { agreements: data?.agreements, loading };
};
